<template>
    <div>
        <div class="pacific-ocean" v-for="(item,index) in expertResult" :key="index">
            <strong><span class="label">太平洋号</span><a @click="contentBp(item.videoArticleFlag)" :href="[item.videoArticleFlag === 1 ? `//hj.pcauto.com.cn/video/${item.articleId}.html` : `//hj.pcauto.com.cn/article/${item.articleId}.html`]" target="_blank" v-html="item.title"></a></strong>
            <a :href="`//hj.pcauto.com.cn/article/${item.articleId}.html`" class="docLink" target="_blank">
                <div class="doc">{{item.content}}</div>
            </a>
            <div class="paragraphInfo">
                <span><i>分类：</i>太平洋号</span>
                <span><i>作者：</i>{{item.authorName}}</span>
                <span><i>时间：</i>{{item.createAt}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PacificOcean',
        props: {
            expertResult: {
                type: Array,
                default: () => ([])
            }
        },
        methods: {
            contentBp(flag) {
                if(flag === 0) {
                    this.countAd(4245)
                }else {
                    this.countAd(4246)
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
.pacific-ocean {
    margin-top: 25px;
    font-size: 12px;
    strong {
        font-weight: normal;
        font-size: 16px;
        line-height: 32px;
        a {
            text-decoration: underline;
            color: #225599;
            ::v-deep em {
                color: #cc0000;
                text-decoration: underline;
                font-style: normal;
            }
        }
    }
    .label {
        color: #eb484f;
        border: 1px solid #eb484f;
        padding: 2px 8px;
        vertical-align: 2px;
        *vertical-align: -1px;
        font-size: 12px;
        margin-right: 6px;
        font-family: Microsoft Yahei;
        border-radius: 2px;
        line-height: 16px;
        display: inline-block;
    }
    .docLink {
        text-decoration: none;
        display: block;
    }
    .doc {
        color: #333333;
        ::v-deep em {
            color: #cc0000;
            text-decoration: underline;
            font-style: normal;
        }
    }
    .paragraphInfo {
        margin-top: 5px;
        span {
            width: 120px;
            display: inline-block;
            color: #333333;
            height: 20px;
            overflow: hidden;
            word-break: break-all;
            word-wrap: break-word;
            margin-right: 5px;
                i {
                    font-style: normal;
                }
        }
    } 
}
</style>